<template>
  <section class="terms-section header-space">
    <div class="container" v-if="langName !== 'ar'">
      <h3 align="center">PRIVACY POLICY</h3>
      <ol type="1">
        <li>
          At Empire Cinemas we respect your privacy. Our Privacy Policy provides
          a concise way your data is collected and used by empirecinemas.com.sa.
        </li>
        <li>
          By accessing the services provided by empirecinemas.com.sa, you agree
          to the collection and use of your data and certain authorized third
          party service providers in the manner provided in this Privacy Policy.
          If you do not agree with this Privacy Policy, please do not use the
          website— empirecinemas.com.sa.
        </li>
        <li>
          This Privacy Policy describes the information we collect from you as
          part of the normal operation of our services and what may happen to
          that information.
        </li>
        <li>
          By accepting this Privacy Policy during registration, you consent to
          the use and disclosure of your personal information in accordance with
          this Privacy Policy. This Privacy Policy is incorporated into and is
          subject to the Terms and Conditions listed in this Site.
        </li>
      </ol>
      <p class="font-weight-bold">ACCOUNT AND REGISTRATION</p>
      <ol type="1">
        <li>
          At empirecinemas.com.sa, we are extremely proud of our commitment to
          protect your privacy. We value your trust in us. Please read the
          following policy to understand how your personal information will be
          treated as you make full use of our Site.
        </li>
        <li>
          Empirecinemas.com.sa promises that we will not sell or rent your
          personal information to third parties (except as provided in this
          Privacy Policy) without your consent. We and/or certain authorized
          third-party service providers will use your personal information to
          provide you with the services offered on empirecinemas.com.sa. From
          time to time, we may reveal general statistical information about our
          site and visitors; i.e. number of visitors, number and type of goods
          and services purchased, etc.
        </li>
      </ol>
      <p class="font-weight-bold">
        WHAT INFORMATION IS OR MAY BE COLLECTED FROM YOU
      </p>
      <ol type="1">
        <li>
          Account information: Your full name, email address, nationality and
          other information you may provide with your account, such as your
          gender, mobile phone number and location.
        </li>
        <li>
          Transactional information: If you make ticket reservations through our
          website, we may collect and store information about the movie name,
          number of tickets booked, cinema location, ticket amount, visited date
          and time.
        </li>
        <li>
          Empirecinemas.com.sa collects the details provided by you upon
          registration with information we learn about you from your use of our
          services and your visits to our site. We also collect information
          about the transactions you undertake, including the details of payment
          cards used.
        </li>
      </ol>
      <p class="font-weight-bold">CREDIT CARD DETAILS</p>
      <ol type="1">
        <li>
          We do not keep any credit card details processed through SSL
          environment in our database or server.
        </li>
        <li>
          We will collect any anonymous traffic information from you when you
          visit our Site. We may also collect the following personally
          identifiable information about you like:
        </li>
        <ol type="A">
          <li>Name, including first and last name</li>
          <li>Mobile phone number and other contact details</li>
          <li>Postal code</li>
          <li>Demographic profile</li>
          <li>Opinions on the features on our website</li>
        </ol>
        <li>
          Empire Cinemas will collect personal identifiable information about
          you only as part of a voluntary registration process, on-line survey,
          or contest or any combination thereof. Our advertisers may collect
          anonymous traffic information from their own assigned cookies to your
          browser.
        </li>
        <li>
          The Site contains links to other websites. We are not responsible for
          the privacy practices of such websites, which we do not own, manage or
          control and we urge you to study the privacy policies of such
          websites.
        </li>
        <li>
          You can terminate your registration at any time. However, your
          information may remain stored in our archives our servers even after
          the deletion and or termination of account.
        </li>
      </ol>

      <p class="font-weight-bold">OUR USE OF YOUR INFORMATION</p>
      <b>EMPIRECINEMAS.COM.SA WILL USE YOUR PERSONAL INFORMATION TO: </b>
      <ol type="1">
        <li>
          Help us provide you with personalized features i.e. understanding of
          our online users (what movies they like, what experiences they prefer,
          what languages they prefer etc.) to improve your next experience with
          Empire Cinemas.
        </li>
        <li>
          Tailor our site to suit your interests i.e. send you communications
          that may be of interest to you by way of emails, SMS or any other mode
          of communication.
        </li>
        <li>Recognize your access privileges to our site.</li>
        <li>
          Track your entries in some of our promotions, sweepstakes and contests
          to indicate a player's progress through the promotion and to track
          entries, submissions, and status in prize drawings.
        </li>
        <li>
          To make an effort to ensure users are not seeing the same
          advertisement repeatedly.
        </li>
        <li>Help diagnose problems with our servers.</li>
      </ol>

      <p class="font-weight-bold">ADMINISTER OUR SITE</p>
      <ol type="1">
        <li>
          To help investigate, prevent or take action regarding unlawful and
          illegal activities, suspected fraud, potential threat to the safety or
          security of any person, violations of empirecinemas.com.sa terms of
          use or to defend against legal claims.
        </li>
        <li>
          To comply with subpoenas, court orders, requests/order from legal
          authorities or law enforcement agencies requiring such disclosure.
        </li>
        <li>
          Choices available to you regarding collection, use and distribution of
          your information.
        </li>
        <li>
          Supplying personal identifiable information is entirely voluntary. You
          are not required to register with us in order to browse our Site. You
          may change your interests at any time and may opt-in or opt-out of any
          marketing / promotional / newsletters mailings. Empirecinemas.com.sa
          reserves the right to send you certain service-related communication
          as it’s considered to be a part of your empirecinemas.com.sa account
          without offering you the facility to opt-out. You may update your
          information and change your account settings at any time.
        </li>
        <li>
          Please contact us for any information placed in the above. 6. Upon
          your request, we will remove/block your personal identifiable
          information from our database, that will thereby cancel your
          registration. However, your information may remain archived on our
          servers even after the deletion or termination of your account.
        </li>
      </ol>

      <p class="font-weight-bold">SECURITY</p>
      <ol type="1">
        <li>
          To protect users against the loss, misuse and alteration of the
          information under our control, we have in place appropriate physical,
          electronic and managerial procedures. For example, our servers are
          accessible only to authorized personnel and your information is shared
          with such personnel only on a need-to-know basis to complete the
          transaction and to provide the services requested by you.
        </li>
        <li>
          Although we will endeavor to safeguard the confidentiality of your
          personally identifiable information, transmissions made by means of
          the Internet cannot be made absolutely secure. By using this site, you
          agree that we will have no liability for disclosure of your
          information due to errors in transmission or unauthorized acts of
          third parties.
        </li>
        <li>
          We reserve the right to change or update our policies at any time.
          Such changes shall be effective immediately upon posting to this site.
          You can offer your views, suggestions, if any, by submitting your
          feedback on complaints@empirecinemas.com.sa.
        </li>
      </ol>

      <p class="font-weight-bold">REFUND POLICY</p>
      <ol type="1">
        <li>
          Movie tickets bought at Empire Cinemas are sold on a non-return,
          replacement or cancellation basis.
        </li>
        <li>No refunds will be issued for an incorrect choice.</li>
      </ol>

      <p class="font-weight-bold">YOUR CONSENT</p>
      <ol type="1">
        <li>
          By using the Site, you consent to the collection and use of the
          information you disclose on the site by empirecinemas.com.sa. If we
          decide to change our Privacy Policy, we will post those changes on
          this page so that you are always aware of what information we collect,
          how we use it, and under what circumstances we disclose it.
        </li>
      </ol>
    </div>
    <div class="container" v-if="langName === 'ar'">
      <h3>سياسة الخصوصية</h3>
      <p>
        <span class="ar-number"> 1.</span> تعتبر خصوصية الزبون اولوية في عالم
        سينما أمبير حيث. توفر السياسة الخاصة بنا طريقة موجزة لجمع بياناتك
        واستخدامها بواسطة empirecinemas.com.sa
      </p>
      <p>
        <span class="ar-number"> 2. </span> من خلال الوصول إلى الخدمات التي
        يقدمها موقعنا ، فإنك توافق على جمع واستخدام البيانات الخاصة بك ولبعض
        مزودي الخدمة المعتمدين من الأطراف الثالثة بالطريقة المنصوص عليها في
        سياسة الخصوصية هذه. إذا كنت لا توافق على سياسة الخصوصية هذه ، فالرجاء
        عدم استخدام هذا الموقع
      </p>
      <p>
        <span class="ar-number"> 3. </span> تصف سياسة الخصوصية هذه المعلومات
        التي نجمعها منك كجزء من الخدمات التي نقدمها بالاضافة الى ماهية استعمال
        هذه المعلومات
      </p>
      <p>
        <span class="ar-number"> 4.</span>

        بقبولك لسياسة الخصوصية هذه أثناء التسجيل، فإنك توافق على استخدام والكشف
        عن معلوماتك الشخصية وفقًا للسياسة هذه. تخضع سياسة الخصوصية هذه للأحكام
        والشروط الواردة في هذا الموقع.
      </p>

      <h4>حساب المشترك وكيفية التسجيل</h4>
      <p>
        <span class="ar-number">1</span> نحن فخورون للغاية بالتزامنا بحماية
        خصوصيتك ضمن هذا الموقع. نحن نقدر ثقتكم بنا لذلك يرجى قراءة السياسة
        التالية من اجل فهم كيفية التعامل مع معلوماتك الشخصية أثناء استخدامك
        الكامل لموقعنا.
      </p>
      <p>
        <span class="ar-number">2</span> يتعهد موقعنا بعدم بيع أو الافصاح عن
        معلوماتك الشخصية لأطراف ثالثة (باستثناء ما هو منصوص عليه في سياسة
        الخصوصية هذه) دون موافقتك. سنستخدم نحن و / أو بعض مزودي الخدمة المعتمدين
        من الجهات الخارجية معلوماتك الشخصية لتزويدك بالخدمات المقدمة على هذا
        الموقع. يجدر الاشارة انه من وقت لآخر ، قد نكشف معلومات إحصائية عامة عن
        موقعنا وزوارنا ؛ أي عدد الزوار وعدد ونوع السلع والخدمات المشتراة ، إلخ.
      </p>

      <h4>ما هي المعلومات من حسابك والتي قد يتم استعمالها</h4>
      <p>
        <span class="ar-number">1.</span> معلومات من الحساب: اسمك الكامل عنوان
        بريدك الإلكتروني جنسيتك والمعلومات الأخرى التي قد تقدمها مع حسابك ، مثل
        الجنس ورقم الهاتف المحمول والموقع الجغرافي لتواجدك.
      </p>
      <p>
        <span class="ar-number">2.</span> معلومات عن حسابك: إذا أجريت حجوزات
        تذاكر عبر موقعنا الإلكتروني ، فقد نقوم بجمع وتخزين المعلومات حول اسم
        الفيلم , عدد التذاكر المحجوزة , موقع السينما , مبلغ التذكرة تاريخ ووقت
        الزيارة
      </p>
      <br />
      <p>
        <span class="ar-number">3</span> يجمع هذا الموقع المعلومات المقدمة عند
        التسجيل بالمعلومات التي يخزنها من خلال استخدامك لخدماتنا وزياراتك
        لموقعنا. نقوم أيضًا بجمع معلومات حول كل العمليات التي تجريها ، بما في
        ذلك تفاصيل بطاقات الدفع المستخدمة.
      </p>
      <h4>تفاصيل بطاقة الائتمان</h4>
      <p>
        <span class="ar-number">1.</span>لا نحتفظ بأي تفاصيل عن بطاقة الائتمان
        في قاعدة البيانات أو االحاسوب الخاص بنا
      </p>
      <p>
        <span class="ar-number">2.</span> سنقوم بجمع أي معلومات مجهولة عندما
        تزور موقعنا. قد نقوم أيضًا بجمع معلومات التعريف الشخصية الخاصة بك مثل:
      </p>
      <ul>
        <li>الاسم الكامل ، بما في ذلك الاسم الأول والأخير</li>
        <li>رقم الهاتف المحمول وتفاصيل الاتصال الأخرى</li>
        <li>رمز بريدي</li>
        <li>الملف الجغرافي</li>
        <li>آراء حول الميزات على موقعنا</li>
      </ul>
      <p>
        <span class="ar-number">3.</span> سوف تجمع امبير سينما المعلومات الشخصية
        عنك فقط كجزء من عملية التسجيل الطوعي أو الاستبيان عبر الإنترنت أو
        المسابقة أو ما ينتج عنها.
      </p>
      <p>
        <span class="ar-number">4.</span>يحتوي الموقع على روابط لمواقع أخرى. نحن
        لسنا مسؤولين عن سياسة الخصوصية لهذه المواقع ، التي لا نمتلكها أو نديرها
        أو نتحكم فيها ، ونحثك على دراسة سياسات الخصوصية لهذه المواقع جيدا قبل
        الدخول اليها.
      </p>
      <p>
        <span class="ar-number">5.</span> يمكنك إلغاء تسجيلك في أي وقت. ومع ذلك
        ، قد تظل معلوماتك مخزنة في أرشيفاتنا وعلى خوادمنا حتى بعد حذف الحساب أو
        إنهائه
      </p>
      <!-- <p>ان موقعنا قد يستعمل معلوماتك الشخصية في الحالات التالية:</p>
      <p>
        مساعدتنا في تزويدك بميزات محددة ، مثل فهم مستخدمينا عبر الإنترنت (ما هي
        الأفلام التي يحبونها ، وما هي التجارب التي يفضلونها ، واللغات التي
        يتقنونها وما إلى ذلك) لكي تكون تجربتك مع سينما امبير فريدة و رائعة صمم
        موقعنا لكي يتوافق مع اهتماماتك و ذلك عبر إرسال معلومات مهمة لك عن طريق
        رسائل
      </p>
      <p>
        صمم موقعنا لكي يتوافق مع اهتماماتك و ذلك عبر إرسال معلومات مهمة لك عن
        طريق رسائل البريد الإلكتروني أو الرسائل النصية القصيرة أو أي وسيلة اتصال
        أخرى
      </p>
      <p>3. التعرف على المميزات و كيفية الوصول إلى موقعنا</p>
      <p>
        تتبع اشتراكك في بعض العروض الترويجية ومسابقات الالعاب والمسابقات الاخرى
        وذلك للإشارة إلى تقدم اللاعب خلال الترويج ولتتبع الحالة في سحوبات
        الجوائز بذل جهد للتأكد من أن المستخدمين لا يرون نفس الإعلان بشكل متكرر.
        المساعدة في اكتشاف الاخطاء في حواسيبنا
      </p> -->
      <!-- <h4>ادارة موقعنا</h4>
      <p>
        المساعدة في التحقيق أو منع أو اتخاذ إجراء بشأن الأنشطة غير القانونية
        والاحتيال المشتبه به ، والتهديد المحتمل لسلامة أو أمن أي شخص ، وانتهاكات
        شروط الاستخدام أو للدفاع ضد المطالبات والشكاوى القانونية.
      </p>
      <p>
        الامتثال لأوامر الاستدعاء وأوامر المحكمة والطلبات / الأوامر من السلطات
        القانونية أو وكالات إنفاذ القانون التي تطلب هذا الكشف.
      </p>
      <p>
        الخيارات المتاحة لك فيما يتعلق بجمع واستخدام وتوزيع المعلومات الخاصة بك
      </p>
      <p>
        تقديم معلومات التعريف الشخصية طوعي تمامًا. لست مضطرا للتسجيل معنا لتصفح
        موقعنا. يمكنك تغيير جميع اهتماماتك في أي وقت ويمكنك الاشتراك أو إلغاء
        الاشتراك في أي رسائل بريدية تسويقية / ترويجية / إخبارية. يحتفظ الموقع
        بالحق في إرسال بعض الرسائل المتعلقة بالخدمة إليك لأنها تعتبر جزءًا من
        حسابك دون تقديم تسهيلات لك لإلغاء الاشتراك. يمكنك تحديث معلوماتك وتغيير
        إعدادات حسابك في أي وقت.
      </p>
      <p>يرجى التواصل معنا للحصول على أي من المعلومات المذكورة أعلاه</p>

      <p>
        بناءً على طلبك ، سنقوم بإزالة / حظر معلومات التعريف الشخصية الخاصة بك من
        قاعدة بياناتنا ، مما يؤدي بالتالي إلى إلغاء تسجيلك تلقائيا. ومع ذلك ، قد
        تظل معلوماتك موجودة و مخزنة في حاسوبنا حتى بعد حذف حسابك أو إنهائه
      </p>
      <p>
        ان الوصول الى المعلومات الشخصية للعملاء والتي هي مصنفة سريا, يحتاج المرء
        الى اذن دخول من شركتنا. ان عدد قليل من الاشخاص مصرح لهم الحصول على
        المعلومات وذلك لحاجتهم لها وذلك خدمة لطلباتك
      </p>
      <p>
        على الرغم من أننا نسعى جاهدين عبر احدث التقنيات للحفاظ على سرية معلوماتك
        الشخصية ، إلا أن عمليات النقل التي تتم عن طريق الإنترنت لا يمكن أن تكون
        آمنة تمامًا. باستخدام هذا الموقع ، فإنك توافق على أننا لن نتحمل أي
        مسؤولية عن الكشف عن معلوماتك بسبب أخطاء في الإرسال أو أفعال غير مصرح بها
        لأطراف ثالث
      </p>
      <p>
        نحتفظ بالحق في تغيير أو تحديث سياساتنا في أي وقت. يجب أن تكون هذه
        التغييرات سارية المفعول فور نشرها على هذا الموقع. يمكنك تقديم آرائك
        واقتراحاتك ، إن وجدت ، عن طريق إرسال ملاحظاتك على
      </p> -->

      <h4>إدارة موقعنا</h4>
      <p>
        <span class="ar-number"> 1.</span>المساعدة في التحقيق أو منع أو اتخاذ
        إجراء بشأن الأنشطة غير القانونية والاحتيال المشتبه به، والتهديد المحتمل
        لسلامة أو أمن أي شخص، وانتهاكات شروط الاستخدام أو للدفاع ضد المطالبات
        والشكاوى القانونية.
      </p>
      <p>
        <span class="ar-number"> 2.</span>الامتثال لأوامر الاستدعاء وأوامر
        المحكمة والطلبات / الأوامر من السلطات القانونية أو وكالات إنفاذ القانون
        التي تطلب هذا الكشف.
      </p>
      <p>
        <span class="ar-number"> 3.</span>الخيارات المتاحة لك فيما يتعلق بجمع
        واستخدام وتوزيع المعلومات الخاصة بك.
      </p>
      <p>
        <span class="ar-number"> 4.</span>تقديم معلومات التعريف الشخصية طوعي
        تمامًا. لست مضطرا للتسجيل معنا لتصفح موقعنا. يمكنك تغيير جميع اهتماماتك
        في أي وقت ويمكنك الاشتراك أو إلغاء الاشتراك في أي رسائل بريدية تسويقية /
        ترويجية / إخبارية. يحتفظ الموقع بالحق في إرسال بعض الرسائل المتعلقة
        بالخدمة إليك لأنها تعتبر جزءًا من حسابك دون تقديم تسهيلات لك لإلغاء
        الاشتراك. يمكنك تحديث معلوماتك وتغيير إعدادات حسابك في أي وقت.
      </p>
      <p>
        <span class="ar-number"> 5.</span>يرجى التواصل معنا للحصول على أي من
        المعلومات المذكورة أعلاه.
      </p>
      <p>
        <span class="ar-number"> 6.</span>سنقوم بإزالة / حظر معلومات التعريف
        الشخصية الخاصة بك من قاعدة بياناتنا وذلك عند طلبك، مما يؤدي بالتالي إلى
        إلغاء تسجيلك تلقائيا. ومع ذلك، قد تظل معلوماتك موجودة ومخزنة في حاسوبنا
        حتى بعد حذف حسابك أو إنهائه.
      </p>

      <h4>الحماية</h4>
      <p>
        <span class="ar-number"> 1.</span>للحماية من فقدان المعلومات الخاضعة
        لسيطرتنا وإساءة استخدامها وتغييرها، لدينا إجراءات مادية وإلكترونية
        وإدارية مناسبة. على سبيل المثال، يمكن الوصول إلى خوادمنا فقط للموظفين
        المعتمدين ويتم مشاركة معلوماتك مع هؤلاء الموظفين فقط على أساس الحاجة إلى
        المعرفة لإكمال المعاملة وتقديم الخدمات التي تطلبها.
      </p>
      <p>
        <span class="ar-number"> 2.</span>على الرغم من أننا نسعى جاهدين عبر أحدث
        التقنيات للحفاظ على سرية معلوماتك الشخصية، إلا أن عمليات النقل التي تتم
        عن طريق الإنترنت لا يمكن أن تكون آمنة تمامًا. باستخدام هذا الموقع، فإنك
        توافق على أننا لن نتحمل أي مسؤولية عن الكشف عن معلوماتك بسبب أخطاء في
        الإرسال أو أفعال غير مصرح بها من أطراف ثالثة.
      </p>
      <p>
        <span class="ar-number"> 3.</span>نحتفظ بالحق في تغيير أو تحديث سياساتنا
        في أي وقت. يجب أن تكون هذه التغييرات سارية المفعول فور نشرها على هذا
        الموقع. يمكنك تقديم آرائك واقتراحاتك، إن وجدت، عن طريق إرسال ملاحظاتك
        على complaints@empirecinemas.com.sa
      </p>

      <h4>سياسة الاسترجاع</h4>
      <p>
        <span class="ar-number"> 1.</span> تباع تذاكر الأفلام التي تم شراؤها في
        سينما امبير على أساس عدم الإرجاع أو الاستبدال أو الإلغاء.
      </p>
      <p>
        <span class="ar-number"> 2.</span> لن يتم إصدار أي مبالغ مستردة بسبب
        اختيار غير صحيح
      </p>

      <h4>موافقتك</h4>
      <p>
        باستخدام هذا الموقع، فإنك توافق على جمع واستخدام المعلومات التي تكشف
        عنها بواسطة تسجيلك فيه. إذا قررنا تحديث سياسة الخصوصية الخاصة بنا،
        فسنقوم بنشر هذه التحديثات على هذه الصفحة حتى تكون دائمًا على إطلاع
        بالمعلومات التي نجمعها وكيف نستخدمها وتحت أي ظروف نكشف عنها.
      </p>
    </div>
  </section>
</template>




<script>
export default {
  beforeCreate: function () {
    document.body.className = 'dark-section'
  },
}
</script>


<style scoped>
.footer {
  background-image: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/privacypolicy.vue